import { Button, SideModal } from "shared";
import { ClientsTable } from "./components";
import { CompanyType } from "types/CompanyTypes";
import "./CompanyInfoModal.scss";
import { isDesktop } from "utils";
import { SharesByCompanyType } from "types/SharesTypes";
import { useGetTransaction } from "hooks/transactions";

interface CompanyInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  company: CompanyType | null;
  setAddClient: (company: CompanyType) => void;
  setEditTransaction: (company: SharesByCompanyType) => void;
  isOtherTab?: boolean;
}

const CompanyInfoModal: React.FC<CompanyInfoModalProps> = ({
  isOpen,
  onClose,
  company,
  setAddClient,
  setEditTransaction,
  isOtherTab = false,
}) => {
  const shareId = company?.shareId
    ? String(company.shareId)
    : company?.shares?.[0]?.id
    ? String(company?.shares[0].id)
    : "";

  const { data: transactionData } = useGetTransaction(shareId);

  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={
        <>
          <p>
            <b>Spółka:</b> {company?.name || "-"}
            {isOtherTab && (
              <>
                | <b>Klient:</b> {company?.name || "-"}
              </>
            )}
          </p>
          <p className="side-modal__subtitle--count">
            Obecna ilość {company?.type === "share" ? "udziałów" : "akcji"}:{" "}
            <span>
              {transactionData && transactionData[0]?.totalShareCount}
            </span>
          </p>
        </>
      }
      className="company-info-modal wide"
    >
      <>
        <Button
          className="button--rounded company-info-modal__button"
          onClick={() => company && setAddClient(company)}
          label="Dodaj transakcję  +"
          styleType={isDesktop() ? undefined : "primary"}
        />
        {isOpen && (
          <ClientsTable
            company={company}
            setEditTransaction={setEditTransaction}
            transactionData={transactionData}
          />
        )}
      </>
    </SideModal>
  );
};

export default CompanyInfoModal;
